// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headers {
  background-color: #FB263B !important;
  padding: 24px 48px !important;
}
.headers .cta-header {
  text-decoration: none;
  font-size: 18px;
  font-family: "Barlow";
  font-weight: 600;
  color: rgb(255, 255, 255);
}

.headers_admin {
  background-color: #FB263B !important;
}

.topheight {
  height: 72px;
}

.modal-dialog {
  margin-top: 15% !important;
}

.MuiFormControl-root.MuiTextField-root {
  width: 100%;
}

.mobile {
  display: none;
}

.desktop {
  display: block;
}

@media screen and (max-width: 426px) {
  .mobile {
    display: block;
  }
  .desktop {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/header.scss"],"names":[],"mappings":"AACA;EACE,oCAAA;EACC,6BAAA;AAAH;AACE;EACE,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;AACJ;;AAEA;EACE,oCAAA;AACF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AAAE;EACE,aAAA;AAGJ;;AADE;EACE,cAAA;AAIJ;;AADA;EACE;IACE,cAAA;EAIF;EAFA;IACE,aAAA;EAIF;AACF","sourcesContent":["@import './colors.scss';\n.headers{\n  background-color: $primary-color!important;  \n   padding: 24px 48px!important;\n  .cta-header{\n    text-decoration: none;\n    font-size: 18px;\n    font-family: \"Barlow\";\n    font-weight: 600;\n    color: rgba(255, 255, 255, 1);\n  }\n}\n.headers_admin{\n  background-color: $primary-color!important;  \n}\n.topheight{\n  height: 72px;\n}\n\n.modal-dialog {\n  margin-top: 15%!important;\n}\n.MuiFormControl-root.MuiTextField-root {\n  width: 100%;\n}\n\n  .mobile{\n    display:none;\n  }\n  .desktop{\n    display:block\n  }\n\n@media screen and (max-width:426px) {\n  .mobile{\n    display:block;\n  }\n  .desktop{\n    display:none\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
